<template>
    <div>
        <nav-app></nav-app>
        <slot></slot>
        <footer-app></footer-app>
    </div>
</template>
<style scoped>
</style>